const config: { [key: string]: string } = {
  prod: 'https://api.pmb.cs.ui.ac.id',
  dev: 'https://pmb-be-staging.ristek.cs.ui.ac.id',
  local: 'https://pmb-be-staging.ristek.cs.ui.ac.id'
}

export default config[process.env.NEXT_PUBLIC_NODE_ENV || 'local']
